import React from 'react';
import factory from 'components/Icons/factory';

export const Hamburger = factory(
  'Hamburger',
  <path
    d="M125,40H3c-1.7,0-3-1.3-3-3v-6c0-1.7,1.3-3,3-3h122c1.7,0,3,1.3,3,3v6C128,38.7,126.7,40,125,40z M125,70H3
      c-1.7,0-3-1.3-3-3v-6c0-1.7,1.3-3,3-3h122c1.7,0,3,1.3,3,3v6C128,68.7,126.7,70,125,70z M125,100H3c-1.7,0-3-1.3-3-3v-6
      c0-1.7,1.3-3,3-3h122c1.7,0,3,1.3,3,3v6C128,98.7,126.7,100,125,100z"
  />
);

export default Hamburger;
